export const IMPACT_LEVELS = Object.freeze(['low', 'medium', 'high']);
export const PRIORITY_LEVELS = Object.freeze(['low', 'medium', 'high']);
export const THREAT_SEVERITY_LEVELS = Object.freeze(['low', 'medium', 'high', 'critical']);

export const normalizeSignalLevel = (value, allowedLevels) => {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toLowerCase();
  return allowedLevels.includes(normalized) ? normalized : null;
};

export const normalizeImpact = (value) => normalizeSignalLevel(value, IMPACT_LEVELS);
export const normalizePriority = (value) => normalizeSignalLevel(value, PRIORITY_LEVELS);
export const normalizeThreatSeverity = (value) => normalizeSignalLevel(value, THREAT_SEVERITY_LEVELS);

export const hasMeaningfulSignalDistribution = (items, getValue, allowedLevels) => {
  const observedLevels = new Set();

  (Array.isArray(items) ? items : []).some((item) => {
    const level = normalizeSignalLevel(getValue(item), allowedLevels);
    if (level) observedLevels.add(level);
    return observedLevels.size > 1;
  });

  return observedLevels.size > 1;
};
